/**
 * Redux reducer for snackbar.
 * @module redux/reducers/snackbar
 */

import update from 'immutability-helper';
import { SHOW_SNACK, DISMISS_SNACK } from '../actions/snackbar';

const initialState = {
  snacks: []
};

const ACTION_HANDLERS = {
  [SHOW_SNACK]: (state, actions) => ({
    snacks: update(state.snacks, {
      $push: [
        {
          id: actions.payload.id,
          data: actions.payload.data
        }
      ]
    })
  }),
  [DISMISS_SNACK]: (state, actions) => {
    const index = state.snacks.findIndex(element => element.id === actions.payload.id);
    if (index >= 0) {
      return {
        snacks: update(state.snacks, { $splice: [[index, 1]] })
      };
    }
    return state;
  }
};

export default function snackbar(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/snackbar.js